<!-- eslint-disable prettier/prettier -->
<h2 mat-dialog-title i18n>Add Users</h2>
<mat-dialog-content>
  <div fxLayout="column" fxLayoutAlign="start stretch">
    <div
      fxLayout="row"
      fxLayoutAlign="start center"
      fxLayoutGap="10px"
      *ngFor="
        let item of data.invitations;
        let index = index;
        trackBy: trackByIndex
      "
    >
      <mat-form-field>
        <mat-label i18n>User Name</mat-label>
        <input
          matInput
          type="text"
          matTooltip="For domain users use 'domain\username'. For local users use '.\username' or just 'username'."
          i18n-matTooltip
          [(ngModel)]="data.invitations[index].username"
          required
          #userName="ngModel"
        />
        <mat-icon class="form-icon" *ngIf="!isAddClicked || (!isUserNameExists(index) && !userName.errors?.required)" matSuffix>person</mat-icon> 
        <mat-icon
            color="warn" matSuffix matTooltipPosition="above" 
            matTooltip="User name is mandatory."   
            i18n-matTooltip                
            *ngIf="isAddClicked && userName.errors?.required"
          >error_outline</mat-icon
        >   
        <mat-icon
          color="warn"
          matSuffix
          matTooltipPosition="above"
          matTooltip="This user already exists!"
          i18n-matTooltip
          *ngIf="isAddClicked && isUserNameExists(index) && !userName.errors?.required"
          >error_outline</mat-icon
        >
      </mat-form-field>
      <mat-form-field>
        <mat-label i18n>Email</mat-label>
        <input
          matInput
          type="email"
          matTooltip="Please enter a valid email"
          [(ngModel)]="data.invitations[index].email"
          required
          #email="ngModel"
          pattern="^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$"
        />
        <mat-icon class="form-icon" *ngIf="!isAddClicked || (!email.errors?.required && !email.errors?.pattern && !isEmailExists(index))" matSuffix>email</mat-icon>
        <mat-icon
          color="warn"
          matSuffix
          matTooltipPosition="above"
          matTooltip="Email is mandatory."
          i18n-matTooltip
          *ngIf="isAddClicked && email.errors?.required"
        >error_outline</mat-icon
      >
      <mat-icon
        color="warn"
        matSuffix
        matTooltipPosition="above"
        matTooltip="Invalid email."
        i18n-matTooltip
        *ngIf="isAddClicked && email.errors?.pattern"
      >error_outline</mat-icon
    >
    <mat-icon
      color="warn"
      matSuffix
      matTooltipPosition="above"
      matTooltip="This user's email already exists!"
      i18n-matTooltip
      *ngIf="isAddClicked && isEmailExists(index) && !email.errors?.required && !email.errors?.pattern"
      >error_outline</mat-icon
    >
      </mat-form-field>
      <mat-form-field>
        <mat-label i18n>Additional User Names</mat-label>
        <input
          matInput
          type="text"
          matTooltip="Additional User Names (comma-separated)"
          i18n-matTooltip
          [ngModel]="data.invitations[index].additionalUsernames.join(',')"
          (ngModelChange)="
            data.invitations[index].additionalUsernames = $event.split(',')
          "
        />
        <mat-icon class="form-icon" *ngIf="aditionalUsersExists(index) === ''" matSuffix>people</mat-icon>
      <mat-icon
        color="warn"
        matSuffix
        matTooltipPosition="above"
        [matTooltip]="'The user name  ' + aditionalUsersExists(index) + '  is already exists!'"
        i18n-matTooltip
        *ngIf="isAddClicked && aditionalUsersExists(index) !== ''"
        >error_outline</mat-icon
      >
      </mat-form-field>      

    </div>
   
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
      <button mat-button (click)="addUser()" i18n>Add User</button>
      <button
        mat-button
        (click)="file.click()"
        i18n
        i18n-matTooltip
        matTooltip="CSV Format: username, email, additionalUsername1, additionalUsername2..."
      >
        Import from CSV
      </button>
      <input
        fxHide
        type="file"
        accept="*.csv;*.txt"
        #file
        (change)="import($any($event.target)?.files[0])"
      />
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions
  fxLayout="row"
  fxLayoutAlign="center center"
  fxLayoutGap="15px"
>
  <button mat-button (click)="add()" *ngIf="!validating" i18n>Add</button>
  <button mat-button *ngIf="validating" disabled i18n>Validating...</button>
  <mat-checkbox [(ngModel)]="data.issueImmediately" i18n
    >Issue Invitations Immediately</mat-checkbox
  >
</mat-dialog-actions>
